module.exports = __webpack_public_path__ + "img/1511295970.17925902.jpg";